import { Component, app, ojs } from "modular-openscriptjs";
import { dom, tool } from "../../fotastart";
import { eParse } from "../../helpers";
import { dc } from "../../declarations";
import { $e } from "../../ojs.events";
import FormField from "../Blocks/FormField";

const h = app("h");
const broker = app("broker");

ojs(FormField);

export default class TransferCapaForm extends Component {
    renderForm(...args) {
        return h.div(
            h.FormField({
                placeholder: "Wallet A/C",
                id: "capa-account-number",
                oninput: this.method("formatAccountNumber", "${this}"),
                label: { value: `Account Number (A/C)` },
                helpText: { value: "The A/C of the recipient" }
            }),
            h.FormField({
                type: "number",
                id: "capa-transfer-amount",
                label: { value: `Amount (${dc.capaSymbol})` },
                helpText: { value: "Amount of capa to transfer" }
            }),
            ...args
        );
    }

    formatAccountNumber(elem) {
        let value = elem.value;

        if (value.length > 0) {
            value = value.replace(/-/g, "");
        }

        let string = value.match(/.{1,2}/g) || [];

        elem.value = string.join("-")?.toUpperCase();
    }

    $$capa = {
        transferred: (ed, event) => {
            let data = eParse(ed);
            dom.id(data.meta.buttons.left)?.click();
        },

        needs: {
            transferForm: (ed, event) => this.showForm(ed, event),
        },

        has: {
            transferError: (ed, event) => {
                let data = eParse(ed);
                const btn = dom.id(data.meta.buttons.right);

                dom.enable(btn);
                dom.put("Transfer", btn);
            },
        },
    };

    async showForm(ed, event) {
        // let data = eParse(ed);

        let options = new tool.ModalOptions();
        options.buttons.right.text = "Transfer";
        options.classes.buttons.right = "btn btn-success";

        options.staticBackdrop();

        const { buttons } = tool.modal(
            "Transfer Capa",
            this.renderForm(),
            options
        );

        buttons.right.button.addEventListener("click", function () {
            dom.disable(this);
            dom.put("Transferring...", this);

            broker.send(
                $e.capa.needs.to.initiateTransfer,
                payload(
                    {
                        amount: dom.id("capa-transfer-amount")?.value ?? 0,
                        account: dom.id("capa-account-number")?.value ?? "",
                    },
                    {
                        buttons: {
                            left: buttons.left.button.id,
                            right: buttons.right.button.id,
                        },
                    }
                )
            );
        });
    }
}

ojs(TransferCapaForm);